/* Go Top Button Start */
var goTopButton1 = $('#goTpButton');
$(window).scroll(function () {
    if ($(window).scrollTop() > 200) {
        goTopButton1.addClass('show-active');
    } else {
        goTopButton1.removeClass('show-active');
    }
});

goTopButton1.bind('click', function () {
    $('html, body').scrollTop(0);
});
/* Go Top Button End */

/* Menu Scroll Start */
$(window).scroll(function() {
    let scrollDistance = $(window).scrollTop(), thisSectionCard1 = $('.cs-section-card-1');

    thisSectionCard1.each(function(i) {
        if ($(this).position().top <= scrollDistance) {
            $('.cs-main-menu-1 a.active').removeClass('active');
            $('.cs-main-menu-1 a').eq(i).addClass('active');
        }
    });
}).scroll();
/* Menu Scroll End */

/* Referances Show/Hide Start */
$(document).ready(function() {
    let resimDiv = $('.referansList > .csr2-col-1').hide(), x = 1;
    let goster = $('#goster');
    let gizle = $('#gizle');
    let funcs = {
        'goster': function() { x= resimDiv.length; show(); },
        'gizle': function() { x=1; show(); }
    }

    $('.cs-button-area-1').on('click', 'button', function(e){
        return (funcs[e.target.id] || function(){})(), false;
    });

    function show() {
        resimDiv.hide().filter(function(i){ return i < (x * 25); }).show();
        goster.show().filter(function(){ return !resimDiv.is(':hidden'); }).hide();
        gizle.show().filter(function(){ return x === 1; }).hide();
    }
    show();

    gizle.click(function(){
        let href = $('#goRef').attr('href');
        window.location.href = href;
    });
});
/* Referances Show/Hide End */